import { CreateAdQualityRule, AdQualityRule } from '@pubstack/common/src/ad-quality-rule'
import { sortByName } from '@pubstack/common/src/sort'
import { useMutation, useQuery } from '@pubstack/http/api-client'

export const AD_QUALITY_RULES_QUERY_KEYS = (scopeId: string) => [scopeId, 'ad-quality-rules']
const ENDPOINT = '/ad-quality-rules'

export const useAdQualityRules = (scopeId: string, enabled = true) => {
  const queryResult = useQuery<AdQualityRule[]>({
    url: ENDPOINT,
    keys: AD_QUALITY_RULES_QUERY_KEYS(scopeId),
    enabled,
    select: sortByName,
  })

  return { ...queryResult, data: queryResult.data || [] }
}

export const useCreateAdQualityRule = (scopeId: string, toast = {}) => {
  return useMutation<CreateAdQualityRule, AdQualityRule>({
    method: 'post',
    url: ENDPOINT,
    collectionKeys: AD_QUALITY_RULES_QUERY_KEYS(scopeId),
    ...toast,
  })
}

export const useUpdateAdQualityRule = (id: string, scopeId: string, toast = {}) => {
  return useMutation<CreateAdQualityRule, AdQualityRule>({
    method: 'put',
    url: `${ENDPOINT}/${id}`,
    collectionKeys: AD_QUALITY_RULES_QUERY_KEYS(scopeId),
    resourceId: id,
    ...toast,
  })
}

export const useDeleteAdQualityRule = (id: string, scopeId: string, toast = {}) => {
  return useMutation({
    method: 'delete',
    url: `${ENDPOINT}/${id}`,
    collectionKeys: AD_QUALITY_RULES_QUERY_KEYS(scopeId),
    resourceId: id,
    ...toast,
  })
}
